export default 'Thu. Sep. 03, 2026 11:17 AM EDT';
